const TEMPLATE_CARD_SELECTOR = '[data-template-card="email"]';
const TEMPLATE_ROOT_SELECTOR = '[data-template-root="email"]';

const applyTemplateRootLayout = (root: HTMLElement) => {
  root.style.margin = "24px 20% 0";
  root.style.width = "750px",
  root.style.maxWidth = "750px";
};

export const unwrapTemplateCardsForSend = (
  html: string
) => {
  if (!html?.trim()) return html || "";
  if (typeof DOMParser === "undefined") return html;

  try {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const templateCards = parsed.querySelectorAll<HTMLElement>(TEMPLATE_CARD_SELECTOR);
    if (!templateCards.length) return html;

    let hasReplacements = false;

    templateCards.forEach((templateCard) => {
      const templateCardBody = templateCard.querySelector<HTMLElement>(
        '[data-template-card-body]'
      );
      const resolvedTemplateBody = templateCardBody?.innerHTML.trim();

      if (!resolvedTemplateBody) return;

      const resolvedTemplateContainer = parsed.createElement("div");
      resolvedTemplateContainer.innerHTML = resolvedTemplateBody;

      const resolvedTemplateFragment = parsed.createDocumentFragment();
      while (resolvedTemplateContainer.firstChild) {
        resolvedTemplateFragment.appendChild(resolvedTemplateContainer.firstChild);
      }

      templateCard.replaceWith(resolvedTemplateFragment);
      hasReplacements = true;
    });

    if (!hasReplacements) return html;
    parsed.querySelectorAll<HTMLElement>(TEMPLATE_ROOT_SELECTOR).forEach(applyTemplateRootLayout);
    return parsed.body.innerHTML.trim();
  } catch (error) {
    console.error("Error unwrapping template cards for send:", error);
    return html;
  }
};
